module.exports = __webpack_public_path__ + "static/media/2122-service-1-5-min.1d95d443.jpg";